var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-options_loading"},_vm._l((5),function(i){return _c('SkeletonLoader',{key:i,staticClass:"select-options__skeleton-item",attrs:{"width":"100%","height":"12px","is-loading":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }